// ====================================================================================
// donation.module
// ====================================================================================

const donations = document.querySelectorAll(".donation-func");

const convertToFloating = (value) => {
  return parseFloat(value.replace(",", "."));
};

export const init = () => {
  let attempts = 0;

  // if document.ready needed
  const whenComplete = () => {
    if (++attempts > 30) return;
    if (document.readyState === "complete") {
      donations.forEach((donation) => {
        let submit = donation.querySelector(".btn");
        let formData = new FormData(donation);
        let data = donation.dataset;
        let radio = formData.get("tw_amount_radio");
        let input = formData.get("tw_amount_input");

        donation.addEventListener("keydown", function (event) {
          if (event.keyCode == 13) {
            event.preventDefault();
            return false;
          }
        });

        submit.addEventListener("click", function (e) {
          e.preventDefault();
          formData = new FormData(donation);

          radio = formData.get("tw_amount_radio");
          input = formData.get("tw_amount_input");

          let amount = 0.0;
          if (radio !== null) amount = radio;
          if (data.placeholder !== undefined) {
            let ph = convertToFloating(data.placeholder);
            amount = ph * data.conv;
          }
          if (input !== null && input !== "") amount = input * data.conv;

          donation.querySelector("input[name=tw_amount]").value = amount;
          donation.submit();
        });
      });
    } else {
      setTimeout(() => {
        whenComplete();
      }, 400);
    }
  };
  whenComplete();
};
